import React from "react";
import classes from "./MyModal.module.css"
const MyModal = function({children, visible, setVisible}){
    const rootClasses = [classes.myModal];
    if (visible){
        rootClasses.push(classes.active);
    }
    // const joinedClasses = rootClasses.join(' ')
    return(
        <div className={rootClasses.join(' ')} onClick={() => setVisible(false)}>
            <div
                style={{width: "50%"}} 
                className={classes.myModalContent} 
                onClick={e => e.stopPropagation()
            }>
                {children}</div>
        </div>
    )
}

export default MyModal;